<template>
  <div
    :id="accordionName"
    class="collapse"
    ref="collapseContainer"
    v-bind:class="{ expanded: susactive, 'collapse-active': collapsed }"
    v-if="!hideUnavailableFacets"
  >
    <details class="accordion" open>
      <summary><slot name="title"></slot></summary>
      <div><slot name="content"></slot></div>
    </details>
  </div>
</template>

<script>
export default {
  name: 'collapse',
  props: {
    expanded: { require: false, default: false },
    productPage: { type: Boolean, require: false, default: false },
    filterPage: { type: Boolean, require: false, default: false },
    isClickOverlayEnabled: { require: false, default: false },
    tagging: { require: false },
    sustainabilitystatus: { type: Object, required: false, default: false },
    collapseIcon: { type: String, require: false },
    accordionName: { type: String, require: false },
    titleText: { type: String, require: false },
  },
  data() {
    return {
      hideUnavailableFacets: false,
      susactive: false,
      id: `collapse${Math.floor(Math.random() * 1000000) + 1}`,
      pdpstickybuynowactive: false,
      payload: false,
    };
  },
  computed: {
    collapseSlotsCollection() {
      return this.$slots.title[0].children[0].text;
    },
  },
  mounted() {
    if (
      this.sustainabilitystatus &&
      this.sustainabilitystatus.active &&
      (this.sustainabilitystatus.active === 'True' ||
        this.sustainabilitystatus.active) &&
      !this.productPage
    ) {
      this.susactive = true;
    }
    if (window.eventBus) {
      window.eventBus.$on('pdp-mobile-collapse', (payload) => {
        this.pdpstickybuynowactive = payload;
      });
    }
  },
};
</script>
